export type ProgramSessionType =
  | 'talk'
  | 'break'
  | 'satellite'
  | 'workshop'
  | 'ceremony'
  | 'social'
  | 'registration'
  | 'meeting';

export interface ProgramSession {
  time: string;
  titleHr: string;
  titleEn?: string;
  authors?: string;
  type: ProgramSessionType;
}

export interface ProgramDay {
  id: string;
  date: string;
  dayHr: string;
  dayEn: string;
  sessions: ProgramSession[];
}

export const congressProgram2026: ProgramDay[] = [
  {
    id: 'cetvrtak',
    date: '01.10.2026.',
    dayHr: 'Četvrtak',
    dayEn: 'Thursday',
    sessions: [
      {
        time: '14:00 – 19:00',
        titleHr: 'Registracija sudionika',
        titleEn: 'Participant Registration',
        type: 'registration'
      },
      {
        time: '16:15 – 16:30',
        titleHr:
          'Primjena kompresivnih i rashladnih rukavica u prevenciji kemoterapijom inducirane periferne neuropatije – pregled literature',
        titleEn:
          'Application of Compression and Cooling Gloves in the Prevention of Chemotherapy-Induced Peripheral Neuropathy – A Literature Review',
        authors: 'Dembić, M., Marinović, V.',
        type: 'talk'
      },
      {
        time: '16:30 – 16:45',
        titleHr:
          'Primjena ledenih kapa u Općoj bolnici Pula – iskustva iz kliničke prakse',
        titleEn:
          'Application of Cold Caps at Pula General Hospital – Clinical Practice Experience',
        authors: 'Špondreht, M., Kerić, A.',
        type: 'talk'
      },
      {
        time: '16:45 – 17:00',
        titleHr: 'Empatija i emocionalna iscrpljenost djelatnika na onkologiji',
        titleEn:
          'Empathy and Emotional Exhaustion Among Oncology Healthcare Professionals',
        authors: 'Pavleka, N.',
        type: 'talk'
      },
      {
        time: '17:00 – 17:45',
        titleHr: 'Komunikacija u onkološkoj praksi – radionica',
        titleEn: 'Communication in Oncology Practice – Workshop',
        authors: 'Poljak, I.',
        type: 'workshop'
      },
      {
        time: '17:45 – 18:30',
        titleHr:
          'Satelitski simpozij AstraZeneca – Nuspojave terapije raka dojke: prepoznati, procijeniti, reagirati',
        titleEn:
          'AstraZeneca Satellite Symposium – Side Effects of Breast Cancer Treatment: Recognize, Assess, Respond',
        authors: 'Miličević, J., Romić, K., Jurić, A.',
        type: 'satellite'
      },
      {
        time: '18:30 – 18:45',
        titleHr:
          'Mučnina i povraćanje uzrokovani kemoterapijom: uloga čimbenika rizika i vodstva onkoloških medicinskih sestara',
        titleEn:
          'Chemotherapy-induced nausea and vomiting: the role of risk factors and oncology nurse leadership',
        authors: 'Molassiotis, A., EONS',
        type: 'talk'
      },
      {
        time: '18:45 – 19:30',
        titleHr: 'Svečano otvaranje',
        titleEn: 'Opening Ceremony',
        type: 'ceremony'
      },
      {
        time: '18:45 – 19:00',
        titleHr: 'Prikaz aktivnosti HDOMST-a 2025./2026.',
        titleEn: 'Overview of HDOMST Activities 2025/2026',
        authors: 'Miličević, J., Kosier, M.',
        type: 'talk'
      },
      {
        time: '19:00 – 19:15',
        titleHr:
          'Europsko društvo onkoloških medicinskih sestara – Osnaživanje medicinskih sestara u onkologiji diljem Europe',
        titleEn:
          'European Oncology Nursing Society – Empowering Cancer Nurses Across Europe',
        authors: 'McInally, W., EONS',
        type: 'talk'
      },
      {
        time: '19:15 – 19:30',
        titleHr: 'Pozdravni govori',
        titleEn: 'Welcome Speeches',
        type: 'ceremony'
      },
      {
        time: '19:30',
        titleHr: 'Domjenak dobrodošlice',
        titleEn: 'Welcome Reception',
        type: 'social'
      }
    ]
  },
  {
    id: 'petak',
    date: '02.10.2026.',
    dayHr: 'Petak',
    dayEn: 'Friday',
    sessions: [
      {
        time: '08:00 – 08:15',
        titleHr:
          'Kolitis uzrokovan imunoterapijom nasuprot kolitisu uzrokovanom kemoterapijom: razumijevanje razlika u procjeni i liječenju – usporedba međunarodnih smjernica',
        titleEn:
          'Immunotherapy- versus Chemotherapy-Induced Colitis: Understanding the Differences in Assessment and Management – A Comparison of International Guidelines',
        authors: 'Stipetić, I., Wilkinson, H.',
        type: 'talk'
      },
      {
        time: '08:15 – 08:35',
        titleHr:
          'Malignitet nepoznatog podrijetla i rak nepoznatog primarnog sijela: suočavanje s neizvjesnošću u akutnoj onkologiji',
        titleEn:
          'Malignancy of Undefined Origin and Cancer of Unknown Primary: Navigating Uncertainty in Acute Oncology',
        authors: 'Roskelly, L.',
        type: 'talk'
      },
      {
        time: '08:35 – 08:55',
        titleHr:
          'Pristup sindromu preklapanja Triple M: unapređenje procjene i zbrinjavanja hitnih onkoloških stanja',
        titleEn:
          'The Triple M Overlap Syndrome Approach: Improving Assessment and Management of Oncology Emergencies',
        authors: 'Wilkinson, H., Stipetić, I.',
        type: 'talk'
      },
      {
        time: '08:55 – 09:15',
        titleHr:
          'Neutropenična sepsa: rano prepoznavanje i zbrinjavanje primjenom NEWS2 i Sepsis Six smjernica UKONS-a te implementacijom uputa za primjenu lijekova za određene skupine pacijenata (PGD)',
        titleEn:
          'Neutropenic Sepsis: Early Recognition and Management Using NEWS2, Sepsis Six, UKONS Guidance, and the Implementation of Patient Group Directions (PGDs)',
        authors: 'Wilkinson, H., Stipetić, I.',
        type: 'talk'
      },
      {
        time: '09:15 – 09:30',
        titleHr:
          'Satelitski simpozij Medical Intertrade – Nove smjernice i suvremena tehnologija u prevenciji komplikacija u onkološkom JIL-u',
        titleEn:
          'Medical Intertrade Satellite Symposium – New Guidelines and Advanced Technology in the Prevention of Complications in the Oncology Intensive Care Unit',
        authors: 'Kosi, M.',
        type: 'satellite'
      },
      {
        time: '09:30 – 09:45',
        titleHr: 'Pružanje palijativne skrbi u Nizozemskoj',
        titleEn: 'Provision of Palliative Care in the Netherlands',
        authors: 'Mlakić, D.',
        type: 'talk'
      },
      {
        time: '09:45 – 10:00',
        titleHr: 'Palijativna skrb i dijete',
        titleEn: 'Palliative Care and the Child',
        authors: 'Saratlija, M., Slijepčević, J., Meštrović, M.',
        type: 'talk'
      },
      {
        time: '10:00 – 10:45',
        titleHr:
          'Satelitski simpozij MSD – Keytruda SC® u kliničkoj praksi: utjecaj supkutane formulacije na svakodnevni rad, organizaciju skrbi i iskustvo bolesnika',
        titleEn:
          'MSD Satellite Symposium – Keytruda SC® in Clinical Practice: The Impact of the Subcutaneous Formulation on Daily Work, Care Organization, and Patient Experience',
        authors: 'Miličević, J., Karabatić, S.',
        type: 'satellite'
      },
      {
        time: '10:45 – 11:00',
        titleHr: 'Stanka za kavu',
        titleEn: 'Coffee Break',
        type: 'break'
      },
      {
        time: '11:00 – 11:30',
        titleHr:
          'Satelitski simpozij Pfizer – Dugotrajno liječenje palbociklibom u prvoj liniji – razgovor s ekspertima',
        titleEn:
          'Pfizer Satellite Symposium – Long-Term Treatment with Palbociclib in the First-Line Setting – A Discussion with Experts',
        authors: 'Romić, K., Jurišić, D.',
        type: 'satellite'
      },
      {
        time: '11:30 – 11:45',
        titleHr:
          'Interakcije sustavne onkološke terapije i stereotaksijske radiokirurgije – na što medicinska sestra kao dio onkološkog tima treba obratiti pažnju? Iskustva Klinike za tumore KBC-a Rijeka',
        titleEn:
          'Interactions Between Systemic Oncology Therapy and Stereotactic Radiosurgery – What Should Nurses as Part of the Oncology Team Pay Attention to? Experience from the Clinical Hospital Centre Rijeka, Tumor Clinic',
        authors: 'Lisica, K., Josipović, B., Gašparuš, S., Čačić, J., Rudić, I., Kolak Radojčić, M., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '11:45 – 12:00',
        titleHr:
          'Medicinska sestra u dijagnostičko-terapijskom procesu onkološkog bolesnika: od PET/CT dijagnostike do radioterapije/radiokirurgije',
        titleEn:
          'The Nurse in the Diagnostic and Therapeutic Management of Oncology Patients: From PET/CT Diagnostics to Radiotherapy/Radiosurgery',
        authors: 'Al Khazae, F.',
        type: 'talk'
      },
      {
        time: '12:00 – 12:15',
        titleHr:
          'Zablude o radioterapiji – uloga medicinske sestre u edukaciji onkoloških bolesnika',
        titleEn:
          'Misconceptions About Radiotherapy – The Role of the Nurse in Educating Oncology Patients',
        authors: 'Bilješko, A., Šoštarić, I.',
        type: 'talk'
      },
      {
        time: '12:15 – 12:30',
        titleHr:
          'Barokomora za liječenje nuspojava stereotaksijske radiokirurgije abdomena i zdjelice – uloga medicinske sestre',
        titleEn:
          'Hyperbaric Oxygen Therapy for the Treatment of Adverse Effects of Stereotactic Radiosurgery of the Abdomen and Pelvis – The Role of the Nurse',
        authors: 'Požgaj, M., Juras, L., Rudić, I., Trečić, I., Lazarić, J., Grubišić, G., Golčić, M., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '12:30 – 12:45',
        titleHr:
          'Stereotaksijska radiokirurgija – 10-mjesečno iskustvo Klinike za tumore KBC-a Rijeka i uloga medicinske sestre u skrbi bolesnika za stereotaksijsku radiokirurgiju',
        titleEn:
          'Stereotactic Radiosurgery – 10-Month Experience of the Clinical Hospital Centre Rijeka, Tumor Clinic, and the Role of the Nurse in Caring for Patients Undergoing Stereotactic Radiosurgery',
        authors: 'Gašparuš, S., Trečić, I., Elbah, S., Lazarić, J., Gračan, I., Ropac, S., Bolf Perić, L., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '12:45 – 13:45',
        titleHr:
          'Radionica BBraun – Rješenja za sigurnu primjenu IV terapije u onkologiji',
        titleEn:
          'BBraun Workshop – Solutions for the Safe Administration of IV Therapy in Oncology',
        authors: 'Filipan, I., Nazor, M.',
        type: 'workshop'
      },
      {
        time: '13:45 – 14:45',
        titleHr: 'Stanka za ručak',
        titleEn: 'Lunch Break',
        type: 'break'
      },
      {
        time: '14:45 – 15:15',
        titleHr:
          'Satelitski simpozij Medison Pharma – Libtayo: iskustvo kliničke prakse iz perspektive medicinske sestre',
        titleEn:
          'Medison Pharma Satellite Symposium – Libtayo: Nursing Perspectives from Clinical Practice',
        authors: 'Jurišić, D., Lazić, D.',
        type: 'satellite'
      },
      {
        time: '15:15 – 15:30',
        titleHr:
          'Uloga medicinske sestre u hitnoj ginekološkoj ambulanti u otkrivanju karcinoma ginekološkog sustava',
        titleEn:
          'The Role of the Nurse in the Emergency Gynecology Clinic in the Detection of Gynecological Cancers',
        authors: 'Studen, I., Sarajlija, K.',
        type: 'talk'
      },
      {
        time: '15:30 – 15:45',
        titleHr: 'Plodnost i neplodnost nakon liječenja kemoterapijom',
        titleEn: 'Fertility and Infertility Following Chemotherapy',
        authors: 'Janeš, S., Tomašić, A.',
        type: 'talk'
      },
      {
        time: '15:45 – 16:00',
        titleHr: 'Seksualno zdravlje u onkologiji',
        titleEn: 'Sexual Health in Oncology',
        authors: 'Božikov, R., Stipić, D.',
        type: 'talk'
      },
      {
        time: '16:00 – 16:45',
        titleHr:
          'Satelitski simpozij Swixx – Supkutana imunoterapija: transformacija svakodnevne kliničke prakse',
        titleEn:
          'Swixx Satellite Symposium – Subcutaneous Immunotherapy: Transforming Everyday Clinical Practice',
        authors: 'Zovko, T.; Romić, K.',
        type: 'satellite'
      },
      {
        time: '16:45 – 17:00',
        titleHr: 'Stanka za kavu',
        titleEn: 'Coffee Break',
        type: 'break'
      },
      {
        time: '17:00 – 17:45',
        titleHr:
          'Satelitski simpozij Novartis – Od dijagnoze do dugoročnog praćenja: uloga medicinske sestre u skrbi bolesnika s rakom dojke',
        titleEn:
          'Novartis Satellite Symposium – From Diagnosis to Long-Term Follow-Up: The Role of the Nurse in the Care of Patients with Breast Cancer',
        authors: 'Miličević, J.; Jurić, A.; Romić, K. (moderator: Robert Šeparović)',
        type: 'satellite'
      },
      {
        time: '17:45 – 18:00',
        titleHr: 'Menadžment boli u pacijentica nakon histerektomije',
        titleEn: 'Pain Management in Patients Following Hysterectomy',
        authors: 'Štajdohar, A., Dugac, P.',
        type: 'talk'
      },
      {
        time: '18:00 – 18:15',
        titleHr:
          'Procjena depresivnosti kod pacijentica oboljelih od karcinoma dojke pomoću PHQ-9 upitnika',
        titleEn:
          'Assessment of Depression in Patients with Breast Cancer Using the PHQ-9 Questionnaire',
        authors: 'Velisavljević, B.',
        type: 'talk'
      },
      {
        time: '18:15 – 18:30',
        titleHr:
          'Neoadjuvantna primjena imuno-kemoterapijskog protokola KEYNOTE-522 kod trostruko negativnog raka dojke',
        titleEn:
          'Neoadjuvant Use of the KEYNOTE-522 Immunochemotherapy Regimen in Triple-Negative Breast Cancer',
        authors: 'Popović, M., Purgar, L., Uroić, M., Silovski, T., Sever, M., Premužak, T.',
        type: 'talk'
      },
      {
        time: '18:30 – 18:45',
        titleHr:
          'Utjecaj onkološke terapije za rak dojke na seksualnost – rezultati Klinike za tumore KBC-a Rijeka',
        titleEn:
          'The Impact of Breast Cancer Treatment on Sexuality – Results from the Clinical Hospital Centre Rijeka, Tumor Clinic',
        authors: 'Francetić, S., Šimunović, K., Ćurić, Z., Požgaj, M., Bukovica, A., Mikolašević, I.',
        type: 'talk'
      }
    ]
  },
  {
    id: 'subota',
    date: '03.10.2026.',
    dayHr: 'Subota',
    dayEn: 'Saturday',
    sessions: [
      {
        time: '09:00 – 09:15',
        titleHr:
          'Više od terapija – kako medicinska sestra/tehničar oblikuje iskustvo onkološkog bolesnika',
        titleEn:
          'More Than Treatment – How Nurses Shape the Oncology Patient Experience',
        authors: 'Lacković, L., Smolić, A., Kosier, M.',
        type: 'talk'
      },
      {
        time: '09:15 – 09:30',
        titleHr: 'Prioritetni pregledi u onkološkoj ambulanti',
        titleEn: 'Priority Examinations in the Oncology Clinic',
        authors: 'Valovčić-Krečak, M., Markov, B.',
        type: 'talk'
      },
      {
        time: '09:30 – 09:45',
        titleHr:
          'Onkološki koordinator i put pacijenta – uloga i rezultati nakon 3 godine od uvođenja',
        titleEn:
          'The Oncology Coordinator and the Patient Journey – Role and Results Three Years After Implementation',
        authors: 'Manestar, J., Beg, A., Ćurić, Z., Šimunović, K., Vidović, K., Požgaj, M., Elbah, S., Mihaljević Ferari, A., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '09:45 – 10:15',
        titleHr:
          'Satelitski simpozij Merck – Erbitux® u svakodnevnoj sestrinskoj praksi: od pripreme pacijenta do uspješnog zbrinjavanja nuspojava',
        titleEn:
          'Merck Satellite Symposium – Erbitux® in Everyday Nursing Practice: From Patient Preparation to Successful Management of Adverse Effects',
        authors: 'Miličević, J., Jurišić, D.',
        type: 'satellite'
      },
      {
        time: '10:15 – 10:30',
        titleHr:
          'Iskustva onkoloških pacijenata s primjenom kemoterapije putem elastomerne pumpe u dnevnoj bolnici: implikacije za sestrinsku edukaciju i kontinuiranu podršku',
        titleEn:
          'Experiences of Oncology Patients Receiving Chemotherapy via Elastomeric Pumps in a Day Hospital: Implications for Nursing Education and Ongoing Support',
        authors: 'Kapitarić, B., Korent, V., Paler, I.',
        type: 'talk'
      },
      {
        time: '10:30 – 10:45',
        titleHr:
          'Onkološka medicinska sestra u intervencijskom ultrazvuku: UZV punkcije lezija abdomena i praktična vrijednost Avatar vaskularnog ultrazvuka za primjenu sustavne onkološke terapije – iskustva Klinike za tumore KBC-a Rijeka',
        titleEn:
          'The Oncology Nurse in Interventional Ultrasound: Ultrasound-Guided Puncture of Abdominal Lesions and the Practical Value of Avatar Vascular Ultrasound for the Administration of Systemic Oncology Therapy – Experience from the Clinical Hospital Centre Rijeka, Tumor Clinic',
        authors: 'Žmirić, R., Bešvir, A., Josipović, B., Francetić, S., Lisica, K., Juras, L., Matulić, S., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '10:45 – 11:45',
        titleHr:
          'Satelitski simpozij Fresenius Kabi – Sigurna primjena parenteralne prehrane',
        titleEn:
          'Fresenius Kabi Satellite Symposium – Safe use of parenteral nutrition',
        authors: 'Horvat, A.',
        type: 'satellite'
      },
      {
        time: '11:45 – 12:00',
        titleHr: 'Stanka za kavu i predstavljanje E-postera',
        titleEn: 'Coffee Break and E-Poster Presentation',
        type: 'break'
      },
      {
        time: '12:00 – 12:30',
        titleHr:
          'Satelitski simpozij Johnson & Johnson – Primjena amivantamaba i zbrinjavanje bolesnika: od teorije do kliničke prakse',
        titleEn:
          'Johnson & Johnson Satellite Symposium – Administration of Amivantamab and Patient Management: From Theory to Clinical Practice',
        authors:
          'Karabatić, S. (Optimizacija liječenja bolesnika s učestalim EGFR mutacijama u eri amivantamaba); Rimac, N. (Uloga onkološke medicinske sestre u multidisciplinarnom timu)',
        type: 'satellite'
      },
      {
        time: '12:30 – 12:45',
        titleHr:
          'Implementacija PICC portova u dnevnoj bolnici Klinike za onkologiju KBC-a Zagreb: rezultati i izazovi',
        titleEn:
          'Implementation of PICC Ports in the Oncology Day Hospital University Hospital Centre Zagreb: Results and Challenges',
        authors: 'Kralj Škoc, V., Diković, A., Kos, M.',
        type: 'talk'
      },
      {
        time: '12:45 – 13:00',
        titleHr:
          'Zbrinjavanje malignih opstrukcija u urologiji (nefrostoma i JJ stentovi): sestrinski protokoli za prevenciju infekcije i urosepse',
        titleEn:
          'Management of Malignant Obstructions in Urology (Nephrostomy and JJ Stents): Nursing Protocols for the Prevention of Infection and Urosepsis',
        authors: 'Miličević, B.',
        type: 'talk'
      },
      {
        time: '13:00 – 13:15',
        titleHr:
          'Utjecaj ciljane terapije na integritet kože kod onkološkog bolesnika: prikaz slučaja',
        titleEn:
          'The Impact of Targeted Therapy on Skin Integrity in an Oncology Patient: A Case Report',
        authors: 'Krajna, H.',
        type: 'talk'
      },
      {
        time: '13:15 – 13:30',
        titleHr:
          'Modulacija crijevne mikrobiote fekalnom mikrobnom transplantacijom kod imunološki posredovanog kolitisa – rezultati Klinike za tumore KBC-a Rijeka i uloga onkološke medicinske sestre',
        titleEn:
          'Modulation of the Gut Microbiota Through Fecal Microbiota Transplantation in Immune-Mediated Colitis – Results from the Clinical Hospital Centre Rijeka, Tumor Clinic, and the Role of the Oncology Nurse',
        authors: 'Gračan, I., Manestar, J., Vidović, K., Juras, L., Bešvir, A., Gašparuš, S., Rudić, I., Zubalj, N., Radoš, L., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '13:30 – 13:45',
        titleHr:
          'Uloga medicinske sestre u kvaliteti zahtjeva za Povjerenstvo za lijekove',
        titleEn:
          'The Role of the Nurse in Ensuring the Quality of Requests Submitted to the Medicines Committee',
        authors: 'Stipić, D.',
        type: 'talk'
      },
      {
        time: '13:45 – 14:30',
        titleHr: 'Stanka za ručak',
        titleEn: 'Lunch Break',
        type: 'break'
      },
      {
        time: '14:30 – 14:45',
        titleHr:
          'Jedinica intenzivne njege Klinike za tumore KBC-a Rijeka – ishodi nakon godinu i pol dana od implementacije',
        titleEn:
          'Intensive Care Unit of the Tumor Clinic of the Clinical Hospital Centre Rijeka – Outcomes One and a Half Years After Implementation',
        authors: 'Juras, L., Bešvir, A., Gračan, I., Josipović, B., Francetić, S., Lisica, K., Skočilić, I., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '14:45 – 15:00',
        titleHr:
          'Jedinica za suportivnu i simptomatsku terapiju Klinike za tumore KBC-a Rijeka',
        titleEn:
          'Supportive and Symptomatic Care Unit of the Clinical Hospital Centre Rijeka, Tumor Clinic',
        authors: 'Vidović, K., Manestar, J., Čačić, J., Prankić, M., Marušić, J., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '15:00 – 15:15',
        titleHr:
          'Sestrinska skrb u pripremi bolesnika za radiojodnu (I-131) ablaciju',
        titleEn:
          'Nursing Care in the Preparation of Patients for Radioiodine (I-131) Ablation',
        authors: 'Burić, T., Krajačić, J., Vlahek, Lj.',
        type: 'talk'
      },
      {
        time: '15:15 – 15:30',
        titleHr:
          'Integracija genomske pismenosti i kompetencija u personaliziranu onkološku zdravstvenu njegu',
        titleEn:
          'Integrating Genomic Literacy and Competencies into Personalized Oncology Nursing Care',
        authors: 'Piškorjanac, S.',
        type: 'talk'
      },
      {
        time: '15:30 – 15:45',
        titleHr: 'AI digitalni asistent Klinike za tumore KBC-a Rijeka',
        titleEn:
          'AI Digital Assistant of the Clinical Hospital Centre Rijeka, Tumor Clinic',
        authors: 'Zubalj, N., Hrvatin, L., Žmirić, R., Velić, C., Šubat, K., Kedžo, D., Košić, A., Cotić, P., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '15:45 – 16:00',
        titleHr: 'Hoće li AI promijeniti ulogu medicinske sestre u onkologiji?',
        titleEn: 'Will AI Change the Role of the Oncology Nurse?',
        authors: 'Stipić, D.',
        type: 'talk'
      },
      {
        time: '16:00 – 16:15',
        titleHr:
          'ENEA program i ENEA aplikacija Klinike za tumore KBC-a Rijeka – rezultati nakon godinu i pol dana od uvođenja',
        titleEn:
          'The ENEA Programme and ENEA Application at the Clinical Hospital Centre Rijeka, Tumor Clinic – Results One and a Half Years After Implementation',
        authors: 'Beg, A., Rudić, I., Lazarić, J., Grubišić, G., Hrvatin, L., Čačić, J., Skočilić, I., Salopek, T., Košić, A., Mikolašević, I.',
        type: 'talk'
      },
      {
        time: '16:15 – 16:30',
        titleHr:
          'Integracija umjetne inteligencije u onkološku sestrinsku praksu: izazovi i mogućnosti',
        titleEn:
          'Integration of Artificial Intelligence into Oncology Nursing Practice: Challenges and Opportunities',
        authors: 'Pongrac, A.',
        type: 'talk'
      },
      {
        time: '16:30 – 16:45',
        titleHr:
          'Stres i posljedice stresa kod zdravstvenih djelatnika na onkološkim odjelima',
        titleEn:
          'Stress and the Consequences of Stress Among Healthcare Professionals in Oncology Departments',
        authors: 'Ulemek, M.',
        type: 'talk'
      },
      {
        time: '16:45 – 17:00',
        titleHr:
          'Profesionalno sagorijevanje kod medicinskih sestara u onkologiji',
        titleEn: 'Professional Burnout Among Oncology Nurses',
        authors: 'Sokolović, S., Marković, M., Gavrilović, M.',
        type: 'talk'
      }
    ]
  },
  {
    id: 'nedjelja',
    date: '04.10.2026.',
    dayHr: 'Nedjelja',
    dayEn: 'Sunday',
    sessions: [
      {
        time: '09:00 – 10:00',
        titleHr: 'Evaluacija kongresa i otvorena diskusija',
        titleEn: 'Congress Evaluation and Open Discussion',
        type: 'ceremony'
      },
      {
        time: '10:00 – 10:30',
        titleHr: 'Predstavljanje zaključaka radionica',
        titleEn: 'Presentation of Workshop Conclusions',
        type: 'ceremony'
      },
      {
        time: '10:30 – 11:00',
        titleHr: 'Predstavljanje najboljih e-postera i usmenih predavanja',
        titleEn: 'Presentation of the Best E-Posters and Oral Presentations',
        authors: 'Komisija / Jury: Ksenija Romić, Ranka Božikov, Marina Dembić',
        type: 'ceremony'
      },
      {
        time: '11:00 – 11:30',
        titleHr: 'Zatvaranje Kongresa',
        titleEn: 'Closing Ceremony',
        type: 'ceremony'
      },
      {
        time: '11:30 – 12:00',
        titleHr: 'Radni sastanak Upravnog odbora HDOMST-a',
        titleEn: 'Executive Board Meeting CONS',
        type: 'meeting'
      },
      {
        time: '12:00 – 12:30',
        titleHr: 'Radni sastanak Skupštine HDOMST-a',
        titleEn: 'General Assembly Meeting CONS',
        type: 'meeting'
      }
    ]
  },
];
